<template>
    <v-dialog v-if="opendialog"
                v-model="opendialog"                
                width="auto"
                style="background-color: white;"
                class="d-flex"                                         
            >
            <v-card>
                <v-card-title class="text-h5">
                Επισκόπηση Ανάθεσης 
                <v-btn @click="requestSave" :loading="buttonloading" icon color="black" style="margin-left: 100px; margin: 40px; text-transform: none; background-color: orange; color: black; border-radius: 5% 5%;width: 300px">
                    <v-icon class="mr-2">mdi-send-variant</v-icon>
                    ΑΠΟΘΗΚΕΥΣΗ ΣΤΟ SOFTONE
                </v-btn>
                <span style="font-size: 0.7em; font-weight: normal; margin-right: 40px;">
                    <v-icon v-if="last_set_status=='ok'" color="green">mdi-check-circle-outline</v-icon><v-icon v-if="last_set_status=='alarm'" color="red">mdi-alert</v-icon>&nbsp;{{ last_set_timestamp ? (new Date(last_set_timestamp)).toLocaleString("el-GR") : '' }}
                </span>
                <v-btn @click="undoSave" :loading="buttonloading" icon color="white" style="margin: 40px; text-transform: none; background-color: black; color: black; border-radius: 5% 5%;width: 380px">
                    <v-icon class="mr-2">mdi-arrow-left</v-icon>
                    ΑΝΑΙΡΕΣΗ ΑΠΟΘΗΚΕΥΣΗΣ ΣΤΟ SOFTONE
                </v-btn>
                <span style="font-size: 0.7em; font-weight: normal; margin-right: 40px;">
                    <v-icon v-if="last_undo_status=='ok'" color="green">mdi-check-circle-outline</v-icon><v-icon v-if="last_undo_status=='alarm'" color="red">mdi-alert</v-icon>&nbsp;{{ last_undo_timestamp ? (new Date(last_undo_timestamp)).toLocaleString("el-GR") : '' }}
                </span>
                <v-btn @click="requestRelease" :loading="buttonloading" icon color="white" style="margin: 40px; text-transform: none; background-color: black; color: black; border-radius: 5% 5%;width: 380px">
                    <v-icon class="mr-2">mdi-message-alert</v-icon>
                    ΔΗΜΟΣΙΕΥΣΗ ΣΤΟΥΣ ΤΕΧΝΚΟΥΣ
                </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-simple-table dense>
                        <template v-slot:default>
                        <thead>
                            <tr>
                            <th class="text-left">
                                Τεχνικός
                            </th>
                            <th class="text-left">
                                Findoc
                            </th>
                            <th class="text-left">
                                Διεύθυνση
                            </th>
                            <th class="text-left">
                                Ώρα
                            </th>
                            <th class="text-left">
                                Πελάτης
                            </th>
                            <th class="text-left">
                                Τηλέφωνο
                            </th>
                            <th class="text-left">
                                Παραστατικό
                            </th>
                            <th class="text-left">
                                Παραστ. Προμηθευτή
                            </th>
                            <th class="text-left">
                                Υπηρεσία (Κωδ)
                            </th>
                            <th class="text-left">
                                Υπηρεσία (Περιγ)
                            </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, index) in items">
                                <tr v-if="index==0 || items[index-1].technician != items[index].technician" :key="item.name + 'separ'" style="background-color: black; color: white;">
                                    <td style="color: white;">{{ item.technician }}</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                                </tr>
                                <tr v-else-if="items[index-1].cust_phone != items[index].cust_phone" :key="item.name + 'separ2'" style="background-color: lightgray;">
                                    <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                                </tr>
                                <tr                                
                                :class="{striked: item.status=='cancel'}"
                                :key="item.name"
                                >                                
                                <td>{{ item.technician }}</td>
                                <td>{{ item.findoc }}</td>
                                <td>{{ item.address }}</td>
                                <td v-if="item.timeslot != null"><v-icon v-if="item.status=='locked'" color="blue">mdi-lock</v-icon>{{ item.timeslot }}</td><td v-else><v-icon color="red">mdi-alert</v-icon></td>
                                <td>{{ item.cust_name }}</td>
                                <td>{{ item.cust_phone }}</td>
                                <td>{{ item.invoice }}</td>
                                <td>{{ item.supplier_docnum }}</td>
                                <td>{{ item.service_type_code }}</td>
                                <td>{{ item.service_type_descr }}</td>

                                </tr>
                            </template>                
                        </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <!--<v-btn @click="requestSave" :loading="buttonloading" icon color="black" style="margin: 40px; text-transform: none; background-color: orange; color: black; border-radius: 5% 5%;width: 200px">
                        <v-icon>mdi-lock</v-icon>
                        Αποθήκευση
                    </v-btn>-->
                </v-card-actions>
            </v-card>                        
    </v-dialog>    
</template>
<script>
import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index";

export default {
    props: {
        opendialog: {
            type: Boolean,
            default: false
        },
        batchcode: {
            type: String,
            default: false
        },
    },
    data() { 
        return {
            items: [],
            last_set_timestamp: null,
            last_set_status: null,
            last_undo_timestamp: null,
            last_undo_status: null,
            buttonloading: false
        }
    },
    watch: {
        async opendialog(newval) {
            if(newval) {
                this.items.splice(0, this.items.length);
                const rsp = await srvApiNoAuth.get(PATH.ASSIGNMENT_PREVIEWRESULT + "/" + this.batchcode);                
                this.items.push(...rsp.data.items);
                this.last_set_timestamp = rsp.data.last_set_timestamp;
                this.last_set_status = rsp.data.last_set_status;
                this.last_undo_timestamp = rsp.data.last_undo_timestamp;
                this.last_undo_status = rsp.data.last_undo_status;
            }
            else{
                this.$emit('closedialog');
            }
        }
    },
    methods: {
        async requestSave() {
            let t = this;
            this.buttonloading=true;
            try {
                const rsp = await srvApiNoAuth.post(PATH.ASSIGNMENT_RELEASEBATCH + "/" + this.batchcode);
                this.last_set_timestamp = rsp.data.last_set_timestamp;
                this.last_set_status = rsp.data.last_set_status;
            } catch (er) {
                
            }
            finally {
                this.buttonloading=false;
            }
        },
        async undoSave() {
            let t = this;
            this.buttonloading=true;
            try {
                const rsp = await srvApiNoAuth.post(PATH.ASSIGNMENT_UNDORELEASEBATCH + "/" + this.batchcode);     
                this.last_undo_timestamp = rsp.data.last_undo_timestamp;
                this.last_undo_status = rsp.data.last_undo_status;               
            } catch (er) {
                
            }
            finally {
                this.buttonloading=false;
            }
        },
        async requestRelease() {
            this.buttonloading=true;
            try {
                const rsp = await srvApiNoAuth.post(PATH.ASSIGNMENT_PUBLISHBATCH + "/" + this.batchcode);                    
            } catch (er) {
                
            }
            finally {
                this.buttonloading=false;
            }
            
        }
    }
}
</script>
<style scoped>

/* tr.striked td:before {
  content: " ";
  position: absolute;
  top: 50%;
  left: 0;
  border-bottom: 2px dashed darkred;
  width: 100%;
}

tr.striked td:after {
  content: "\00B7";
  font-size: 2px;  
} */

tr.striked {
    background-color: lightsalmon;
}

tr.striked td {
    font-style: italic !important;
    text-decoration: line-through;

}
</style>